import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const FORM_FOOTER_CLASS_NAME = 'FormFooter';
export const FORM_FOOTER_CLASS_SLOTS = ['root'] as const;

export type FormFooterClassSlot = (typeof FORM_FOOTER_CLASS_SLOTS)[number];

export interface FormFooterClasses {
	root: string;
}

export type FormFooterClassKey = keyof FormFooterClasses;

export const getFormFooterUtilityClass = (slot: string) =>
	generateUtilityClass(FORM_FOOTER_CLASS_NAME, slot);

export const formFooterClasses = generateUtilityClasses<
	keyof FormFooterClasses
>(FORM_FOOTER_CLASS_NAME, ['root']);
export default formFooterClasses;
